import {
  GET_ADMIN_INSURANCE_CARRIERS,
  GET_ADMIN_INSURANCE_CARRIERS_SUCCESS,
  GET_ADMIN_INSURANCE_CARRIERS_ERROR,
  CRETE_ADMIN_INSURANCE_CARRIER,
  CRETE_ADMIN_INSURANCE_CARRIER_SUCCESS,
  CRETE_ADMIN_INSURANCE_CARRIER_ERROR,
  UPDATE_ADMIN_INSURANCE_CARRIER,
  UPDATE_ADMIN_INSURANCE_CARRIER_SUCCESS,
  UPDATE_ADMIN_INSURANCE_CARRIER_ERROR
} from "./actionTypes"

const INIT_STATE = {
  admin_insurance_carriers: [],
  error: null,
  loading: false,
}
const AdminInsuranceCarriers = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_ADMIN_INSURANCE_CARRIERS:
      return {
        ...state,
        loading: true
      }

    case GET_ADMIN_INSURANCE_CARRIERS_SUCCESS:
      return {
        ...state,
        loading: false,
        admin_insurance_carriers: action.payload
      }

    case GET_ADMIN_INSURANCE_CARRIERS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload
      }

    case CRETE_ADMIN_INSURANCE_CARRIER:
      return {
        ...state,
        loading: true
      }

    case CRETE_ADMIN_INSURANCE_CARRIER_SUCCESS:
      return {
        ...state,
        loading: false,
        admin_insurance_carriers: [...state.admin_insurance_carriers, action.payload]
      }

    case CRETE_ADMIN_INSURANCE_CARRIER_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload
      }

    case UPDATE_ADMIN_INSURANCE_CARRIER:
      return {
        ...state,
        loading: true
      }

    case UPDATE_ADMIN_INSURANCE_CARRIER_SUCCESS:
      return {
        ...state,
        loading: false,
        admin_insurance_carriers: state.admin_insurance_carriers.map((item) => item.id === action.payload.id ? action.payload : item)
      }

    case UPDATE_ADMIN_INSURANCE_CARRIER_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload
      }

    default:
      return state
  }
}

export default AdminInsuranceCarriers
